import * as types from '../actions/actionTypes';
import initialState from './initialState';

        
export default function crucigramaReducer(state= initialState.crucigrama, action){
    let newState;
	switch(action.type){
         case types.LOAD_CRUCIGRAMA_LIST_SUCCESS:		
            action.crucigrama.filtroActivo=state.filtroActivo;
            action.crucigrama.filtroActual=state.filtroActual;
            action.crucigrama.showActivos=state.showActivos;
			 action.crucigrama.paginaActual=action.crucigrama.pageable.pageNumber;
			 action.crucigrama.registrosPorPagina=action.crucigrama.size;
            
            return action.crucigrama;

        case types.BORRAR_CRUCIGRAMA_SUCCESS:		            
            newState=Object.assign({}, state);
            newState.content=[...state.content.filter(crucigrama => crucigrama.id !== action.crucigrama.id)];          
			return newState;    
            
        case types.ACTIVAR_CRUCIGRAMA_SUCCESS:		            
            newState=Object.assign({}, state);
            newState.content=[...state.content.filter(crucigrama => crucigrama.id !== action.crucigrama.id)];          
			 return newState;
            
        case types.SET_FILTRO_CRUCIGRAMA:
			newState=Object.assign({}, state);
			newState.filtroActivo=action.filtro.filtroActivo;
			newState.filtroActual=action.filtro.filtroActual;
           newState.showActivos=action.filtro.showActivos;
            
            
			return newState;
		break;
            
		default:
			return state;
	}
}